import type { ProductAdmin, ProductAdminFields, ProductAdminFieldsBody, ProductAdminResponse } from '../types';

export function mapProductAdmin(data: ProductAdminResponse): ProductAdmin {
  return {
    id: data.id,
    description: data.description,
    type: data.type,
    isActive: data.is_active,
    isFeatured: data.is_featured,
    isAppleEnabled: data.is_apple_enabled,
    isGoogleEnabled: data.is_google_enabled,
    isPrayEnabled: data.is_pray_enabled,
    isSubscription: data.is_subscription,
    subscriptionInterval: data.subscription_interval,
    subscriptionIntervalCount: data.subscription_interval_count,
    freeTrialInterval: data.free_trial_interval,
    freeTrialIntervalCount: data.free_trial_interval_count,
    sku: data.sku,
    skuApple: data.sku_apple,
    skuGoogle: data.sku_google,
    price: data.price,
    publishedStartedAt: data.published_started_at,
    publishedEndedAt: data.published_ended_at,
    destroyed: data.destroyed,
    createdAt: data.created_at,
    updatedAt: data.updated_at,
  };
}

/** camelCase fields -> wire body, keeping only the keys that were provided. */
export function mapProductFieldsToBody(fields: ProductAdminFields): ProductAdminFieldsBody {
  /* eslint-disable camelcase */
  const body: ProductAdminFieldsBody = {
    description: fields.description,
    type: fields.type,
    is_featured: fields.isFeatured,
    is_apple_enabled: fields.isAppleEnabled,
    is_google_enabled: fields.isGoogleEnabled,
    is_pray_enabled: fields.isPrayEnabled,
    is_subscription: fields.isSubscription,
    subscription_interval: fields.subscriptionInterval,
    subscription_interval_count: fields.subscriptionIntervalCount,
    free_trial_interval: fields.freeTrialInterval,
    free_trial_interval_count: fields.freeTrialIntervalCount,
    sku: fields.sku,
    sku_apple: fields.skuApple,
    sku_google: fields.skuGoogle,
    published_started_at: fields.publishedStartedAt,
    published_ended_at: fields.publishedEndedAt,
  };
  /* eslint-enable camelcase */

  return Object.fromEntries(Object.entries(body).filter(([, value]) => value !== undefined)) as ProductAdminFieldsBody;
}
